import {
  BarChartSquareIcon,
  BarLineChartDottedIcon,
  BeakerIcon,
  BellIcon,
  BookOpenIcon,
  BriefCaseIcon,
  BriefCaseLinesIcon,
  CalculatorIcon,
  CheckVerifiedIcon,
  HelpCircleIcon,
  HomeIcon,
  MessageCheckSquareIcon,
  PieChartIcon,
  PresentationIcon,
  SertificateIcon,
  UsersIcon,
  UsersUpIcon,
  YoutubeIcon,
  ZapIcon,
} from "../../../../assets/icons";
import { Paths } from "../../../../router/paths";
import type { MenuItem } from "./Menu";
import { CategoryIcon, PromocodeIcon } from "./menuIcons";

// Super Admin Menu Items
export const dashboardMenuItem: MenuItem = {
  key: Paths.DASHBOARD,
  labelKey: "nav.dashboard",
  icon: <BarChartSquareIcon />,
};

export const usersMenuItem: MenuItem = {
  key: Paths.USERS,
  labelKey: "nav.users",
  icon: <UsersIcon />,
};

export const adminRolesMenuItem: MenuItem = {
  key: Paths.ADMIN_ROLES,
  labelKey: "nav.adminRoles",
  icon: <UsersUpIcon />,
};

export const subscriptionsMenuItem: MenuItem = {
  key: Paths.SUBSCRIPTIONS,
  labelKey: "nav.subscriptions",
  icon: <CheckVerifiedIcon />,
};

export const subscriptionMatrixMenuItem: MenuItem = {
  key: Paths.SUBSCRIPTION_MATRIX,
  labelKey: "nav.subscriptionMatrix",
  icon: <CheckVerifiedIcon />,
};

export const stockAnalysesMenuItem: MenuItem = {
  key: Paths.STOCK_ANALYSES,
  labelKey: "nav.stockAnalyses",
  icon: <PieChartIcon />,
};

export const topHalalStocksMenuItem: MenuItem = {
  key: Paths.TOP_HALAL_STOCKS,
  labelKey: "nav.topHalalStocks",
  icon: <BarChartSquareIcon />,
};

export const portfoliosMenuItem: MenuItem = {
  key: Paths.PORTFOLIOS,
  labelKey: "nav.portfoliosPreMade",
  icon: <BriefCaseIcon />,
};

export const readyMadePortfolioMenuItem: MenuItem = {
  key: Paths.READY_MADE_PORTFOLIO,
  labelKey: "nav.readyMadePortfolio",
  icon: <BriefCaseIcon />,
};

export const academyMenuItem: MenuItem = {
  key: Paths.ACADEMY,
  labelKey: "nav.akindaAcademy",
  icon: <BookOpenIcon />,
};

export const articlesMenuItem: MenuItem = {
  key: Paths.ARTICLES,
  labelKey: "nav.articles",
  icon: <SertificateIcon />,
};

export const articleCategoriesMenuItem: MenuItem = {
  key: Paths.ARTICLE_CATEGORIES,
  labelKey: "nav.articleCategories",
  icon: <CategoryIcon />,
};

export const webinarsMenuItem: MenuItem = {
  key: Paths.WEBINARS,
  labelKey: "nav.webinars",
  icon: <YoutubeIcon />,
};

export const supportTicketsMenuItem: MenuItem = {
  key: Paths.SUPPORT_TICKETS,
  labelKey: "nav.supportTickets",
  icon: <HelpCircleIcon />,
};

export const notificationsMenuItem: MenuItem = {
  key: Paths.NOTIFICATIONS,
  labelKey: "nav.notifications",
  icon: <BellIcon />,
};

export const homeMenuItem: MenuItem = {
  key: Paths.HOME,
  labelKey: "nav.home",
  icon: <HomeIcon />,
};

export const marketNewsMenuItem: MenuItem = {
  key: Paths.MARKET_NEWS,
  labelKey: "nav.marketNews",
  icon: <ZapIcon />,
};

export const stockScreenerMenuItem: MenuItem = {
  key: Paths.STOCK_SCREENER,
  labelKey: "nav.stockScreener",
  icon: <PresentationIcon />,
};

export const etfScreenerMenuItem: MenuItem = {
  key: Paths.ETF_SCREENER,
  labelKey: "nav.etfScreener",
  icon: <PresentationIcon />,
};

export const screeningMenuItem: MenuItem = {
  key: Paths.SCREENING,
  labelKey: "nav.screening",
  icon: <PresentationIcon />,
};

export const insiderBySectorMenuItem: MenuItem = {
  key: Paths.INSIDER_BY_SECTOR,
  labelKey: "nav.insiderBySector",
  icon: <BarLineChartDottedIcon />,
};

export const dividendMenuItem: MenuItem = {
  key: Paths.DIVIDEND,
  labelKey: "nav.dividend",
  icon: <PieChartIcon />,
};

export const investingCalculatorMenuItem: MenuItem = {
  key: Paths.INVESTING_CALCULATOR,
  labelKey: "nav.investingCalculator",
  icon: <CalculatorIcon />,
};

export const zakatCalculatorMenuItem: MenuItem = {
  key: Paths.ZAKAT_CALCULATOR,
  labelKey: "nav.zakatCalculator",
  icon: <CalculatorIcon />,
};

export const purificationCalculatorMenuItem: MenuItem = {
  key: Paths.PURIFICATION_CALCULATOR,
  labelKey: "nav.purificationCalculator",
  icon: <CalculatorIcon />,
};

export const myPortfolioMenuItem: MenuItem = {
  key: Paths.MY_PORTFOLIO,
  labelKey: "nav.myPortfolio",
  icon: <BriefCaseIcon />,
};

export const portfolioTrackingMenuItem: MenuItem = {
  key: Paths.PORTFOLIO_TRACKING,
  labelKey: "nav.portfolioTracking",
  icon: <BriefCaseLinesIcon />,
};

export const portfolioBacktestingMenuItem: MenuItem = {
  key: Paths.PORTFOLIO_BACKTESTING,
  labelKey: "nav.portfolioBacktesting",
  icon: <BeakerIcon />,
};

export const akindaAiMenuItem: MenuItem = {
  key: Paths.AKINDA_AI,
  labelKey: "nav.akindaAi",
  icon: <BeakerIcon />,
};

export const communityMenuItem: MenuItem = {
  key: Paths.COMMUNITY,
  labelKey: "nav.community",
  icon: <UsersIcon />,
};

export const backtestingMenuItem: MenuItem = {
  key: Paths.BACKTESTING,
  labelKey: "nav.backtesting",
  icon: <BarLineChartDottedIcon />,
};

export const promocodesMenuItem = {
  key: Paths.PROMOCODES,
  labelKey: "nav.promocodes",
  icon: <PromocodeIcon />,
};

export const financeMenuItem: MenuItem = {
  key: Paths.FINANCE,
  labelKey: "nav.finance",
  icon: <PieChartIcon />,
};

export const referralMenuItem: MenuItem = {
  key: Paths.REFERRAL,
  labelKey: "nav.referral",
  icon: <UsersUpIcon />,
};

export const adminReferralMenuItem: MenuItem = {
  key: Paths.ADMIN_REFERRAL,
  labelKey: "nav.referral",
  icon: <UsersUpIcon />,
};

export const onboardingQuestionsMenuItem: MenuItem = {
  key: Paths.ONBOARDING_QUESTIONS,
  labelKey: "nav.onboardingQuestions",
  icon: <MessageCheckSquareIcon />,
};

export const onboardingStatsMenuItem: MenuItem = {
  key: Paths.ONBOARDING_STATS,
  labelKey: "nav.onboardingStats",
  icon: <BarLineChartDottedIcon />,
};

/** Onboarding section — dynamic onboarding wizard questions and their analytics. */
const onboardingMenuGroup = [
  onboardingQuestionsMenuItem,
  onboardingStatsMenuItem,
];

const superAdminMenu = [
  [
    homeMenuItem,
    dashboardMenuItem,
    usersMenuItem,
    adminRolesMenuItem,
    subscriptionsMenuItem,
    subscriptionMatrixMenuItem,
    promocodesMenuItem,
    financeMenuItem,
    adminReferralMenuItem,
  ],
  [stockAnalysesMenuItem, topHalalStocksMenuItem, stockScreenerMenuItem, etfScreenerMenuItem, myPortfolioMenuItem, readyMadePortfolioMenuItem],
  [academyMenuItem, articlesMenuItem, articleCategoriesMenuItem],
  [webinarsMenuItem, notificationsMenuItem],
  onboardingMenuGroup,
  [akindaAiMenuItem, communityMenuItem, backtestingMenuItem, investingCalculatorMenuItem, zakatCalculatorMenuItem, purificationCalculatorMenuItem],
];

export const menuItems = {
  "super-admin": superAdminMenu,
  owner: superAdminMenu,
  admin: [
    [
      dashboardMenuItem,
      marketNewsMenuItem,
      usersMenuItem,
      subscriptionsMenuItem,
      adminReferralMenuItem,
    ],
    [stockAnalysesMenuItem, topHalalStocksMenuItem, stockScreenerMenuItem, etfScreenerMenuItem, myPortfolioMenuItem, readyMadePortfolioMenuItem],
    [academyMenuItem, articlesMenuItem, articleCategoriesMenuItem],
    [webinarsMenuItem, supportTicketsMenuItem, notificationsMenuItem],
    onboardingMenuGroup,
    [akindaAiMenuItem, communityMenuItem, backtestingMenuItem, investingCalculatorMenuItem, zakatCalculatorMenuItem, purificationCalculatorMenuItem],
  ],
  editor: [
    [
      stockAnalysesMenuItem,
      marketNewsMenuItem,
      topHalalStocksMenuItem,
      stockScreenerMenuItem,
      etfScreenerMenuItem,
      portfoliosMenuItem,
      readyMadePortfolioMenuItem,
      articlesMenuItem,
      articleCategoriesMenuItem,
    ],
    [articlesMenuItem, articleCategoriesMenuItem],
    onboardingMenuGroup,
    [akindaAiMenuItem, communityMenuItem, backtestingMenuItem, investingCalculatorMenuItem, zakatCalculatorMenuItem, purificationCalculatorMenuItem],
  ],
  analitik: [
    [
      homeMenuItem,
      marketNewsMenuItem,
      topHalalStocksMenuItem,
      stockScreenerMenuItem,
      etfScreenerMenuItem,
      stockAnalysesMenuItem,
      myPortfolioMenuItem,
      readyMadePortfolioMenuItem,
      academyMenuItem,
      articlesMenuItem,
      webinarsMenuItem,
    ],
    [akindaAiMenuItem, communityMenuItem, backtestingMenuItem, investingCalculatorMenuItem, zakatCalculatorMenuItem, purificationCalculatorMenuItem],
  ],
  support: [
    [
      academyMenuItem,
      marketNewsMenuItem,
      stockScreenerMenuItem,
      etfScreenerMenuItem,
      supportTicketsMenuItem,
      usersMenuItem,
    ],
    [akindaAiMenuItem, communityMenuItem, backtestingMenuItem, investingCalculatorMenuItem, zakatCalculatorMenuItem, purificationCalculatorMenuItem],
  ],
  user: [
    [
      homeMenuItem,
      topHalalStocksMenuItem,
      stockScreenerMenuItem,
      etfScreenerMenuItem,
      stockAnalysesMenuItem,
      myPortfolioMenuItem,
      readyMadePortfolioMenuItem,
      academyMenuItem,
      articlesMenuItem,
      webinarsMenuItem,
      subscriptionsMenuItem,
      referralMenuItem,
    ],
    [akindaAiMenuItem, communityMenuItem, backtestingMenuItem, investingCalculatorMenuItem, zakatCalculatorMenuItem, purificationCalculatorMenuItem],
  ],
  unauthorized: [
    [
      homeMenuItem,
      topHalalStocksMenuItem,
      stockScreenerMenuItem,
      etfScreenerMenuItem,
      stockAnalysesMenuItem,
      myPortfolioMenuItem,
      readyMadePortfolioMenuItem,
      academyMenuItem,
      articlesMenuItem,
      webinarsMenuItem,
    ],
    [akindaAiMenuItem, communityMenuItem, backtestingMenuItem, investingCalculatorMenuItem, zakatCalculatorMenuItem, purificationCalculatorMenuItem],
  ],
};

const IOS_HIDDEN_MENU_KEYS = new Set<string>([
  Paths.SUBSCRIPTIONS,
  Paths.SUBSCRIPTION_MATRIX,
]);

const MOBILE_HIDDEN_MENU_KEYS = new Set<string>([
  Paths.ACADEMY,
  Paths.WEBINARS,
]);

/**
 * Role menu groups with subscription entries removed (iPhone App Store compliance).
 */
export const getMenuItemsForRole = (
  roleName: string | undefined,
  options?: { hideSubscriptions?: boolean; hideMobileOnly?: boolean },
): MenuItem[][] => {
  const roleKey =
    (roleName as keyof typeof menuItems) in menuItems
      ? (roleName as keyof typeof menuItems)
      : "unauthorized";
  const groups = menuItems[roleKey] ?? menuItems.unauthorized;

  const hiddenKeys = new Set<string>();
  if (options?.hideSubscriptions) {
    IOS_HIDDEN_MENU_KEYS.forEach((key) => hiddenKeys.add(key));
  }
  if (options?.hideMobileOnly) {
    MOBILE_HIDDEN_MENU_KEYS.forEach((key) => hiddenKeys.add(key));
  }

  if (hiddenKeys.size === 0) {
    return groups;
  }

  return groups
    .map((group) => group.filter((item) => !hiddenKeys.has(item.key)))
    .filter((group) => group.length > 0);
};
